/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../../common/controller/list-helper.service';
import {Component, Inject, OnInit} from '@angular/core';
import {ApiKeyResource} from '../../../components/api/resources/resource/api-key.resource';
import {LocalUserPermissions} from '../../../components/session/local-user-permissions';

@Component({
  standalone: false,
  selector: 'adn-api-key-route-page',
  template: `
    <adn-api-key-list-page
      *ngIf="list"
      [list]="list">
    </adn-api-key-list-page>
  `
})
export class ApiKeyRoutePageComponent implements OnInit {
  list: any = {};

  constructor(
    private readonly adnListHelper: AdnListHelperService,
    @Inject(ApiKeyResource) private readonly ApiKey: any,
    @Inject(LocalUserPermissions) private readonly LocalUserPermissions: any
  ) {
  }

  ngOnInit(): void {
    const readOnly = this.LocalUserPermissions.isSelfServiceOwn();
    this.adnListHelper.setUpList(this.list, this.ApiKey, readOnly, 'fullApiKeyList', {
      baseTable: 'apiKey'
    });
  }
}
